import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <path
    d="M6.48071 3.69225V11.5768C6.48071 12.0243 6.63813 12.4054 6.95296 12.7202C7.26763 13.0349 7.64871 13.1923 8.09621 13.1923H17.0845L14.9845 15.2923L15.6922 16L19 12.6923L15.6922 9.3845L14.9845 10.0922L17.0845 12.1923H8.09621C7.91671 12.1923 7.76921 12.1346 7.65371 12.0193C7.53838 11.9038 7.48071 11.7563 7.48071 11.5768V3.69225H6.48071Z"
    fill="currentColor"
  />,
  'TurnRight',
)
